export const engagementProductRecommendationsRecommenderId =
  "/engagement/product_recommendations(/:recommender_id)";
